module.exports = __webpack_public_path__ + "static/media/april.fac0972c.png";